import { createContext, useContext } from "react";

// ----------- Провайдер опции для создания водителей ------------

export type DriversMailingCreateOptions = {
  overrides?: {
    onSubmit: () => void;
  };
  toggleRecipient?: {
    onToggleRecipient: () => void;
  };
  applySegmentFilter?: boolean;
  applyGroupsFilter?: boolean;
  applyStagesFilter?: boolean;
  enableSegmentFilterAll?: boolean;
  enableV2Select?: boolean;
  enableMailingTypeSegments?: boolean;
  enableWhatsappLimitNotification?: boolean;
  enableMailingTemplates?: boolean;
  enableFilterByGroup?: boolean;
  enableHasNotStationBadge?: boolean;
  enableBadgesGroups?: boolean;

  onMailingCreated?: (params: {
    template?: string;
    type: "pro" | "whatsapp";
  }) => void;
  onTemplateChanged?: (params: { template_id?: string }) => void;
  onTypeChanged?: (params: { value: "pro" | "whatsapp" }) => void;
  onTextEditorActionClicked?: (params: {
    action: "bold" | "italic" | "link" | "list";
  }) => void;
  onTextEditorPreviewToggled?: (params: { enabled: boolean }) => void;
  onSegmentChanged?: (params: { value?: string }) => void;
  onSubsegmentsChanged?: (params: { segments?: string[] }) => void;
  onGroupFilterChanged?: (params: { group?: string }) => void;
  onFilterChanged?: (params: { name: string }) => void;
};

const driversMailingCreateOptionsContext =
  createContext<DriversMailingCreateOptions>({});

export const DriversMailingCreateOptionsProvider =
  driversMailingCreateOptionsContext.Provider;

export const useDriversMailingCreateOptions = () =>
  useContext(driversMailingCreateOptionsContext);

// ----------- Провайдер опций для просмотра водителей ------------

export type DriversMailingViewOptions = {
  showSegmentFilter?: boolean;
  showGroupsFilter?: boolean;
  showStagesFilter?: boolean;
  enableNewForm?: boolean;
};

const driversMailingViewOptionsContext =
  createContext<DriversMailingViewOptions>({});

export const DriversMailingViewOptionsProvider =
  driversMailingViewOptionsContext.Provider;

export const useDriversMailingViewOptions = () =>
  useContext(driversMailingViewOptionsContext);
